import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";

// thunk to extract the user details from token and update the state.
export const updateToken = createAsyncThunk(
    'authReducer/updateToken',
    async (token) => {
        var decodedToken = jwtDecode(token);
        return decodedToken;
    }
);

const authReducer = createSlice({
    name: 'authReducer',
    initialState: {
        userDetails: { name: '', preferred_username: '', email: '', isFirstTimeLogin: false },
        token: '',
    },
    reducers: {
        resetAuthState: (state, action) => {
            state.token = '';
            state.userDetails = { name: '', preferred_username: '', email: '', isFirstTimeLogin: false }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(updateToken.fulfilled, (state, action) => {
            state.userDetails = {
                name: action.payload.name,
                preferred_username: action.payload.preferred_username,
                email: action.payload.email
            };
            state.token = action.meta.arg;
            const lf = localStorage.getItem('lf');
            // const fl = localStorage.getItem('fl');
            state.loggedInFrom = lf;
            // state.userDetails.isFirstTimeLogin = fl;
        })
    }
})

export const { resetAuthState } = authReducer.actions;

export default authReducer.reducer;